"use strict";module.exports={HYPERLINK:"hyperlink",ENTRY_HYPERLINK:"entry-hyperlink",ASSET_HYPERLINK:"asset-hyperlink",EMBEDDED_ENTRY:"embedded-entry-inline"};
